import React from 'react';
import PropTypes from 'prop-types';
import { Div, Button, CenteredContainer, Flex, Link } from 'Common';
import { Text } from 'Common/components/Atoms/Text';
import UnauthedHeader from '../../components/UnauthedHeader';
import { Email } from 'constants/email';
import { mail } from 'fluent-mailto';
import { withTheme } from '@mui/styles';

export class RatingConfirmation extends React.Component {
  state = {
    helpfulnessChanged: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { hasConfirmed, receivedConfirmation } = this.props;
    if (!prevProps.hasConfirmed && hasConfirmed) {
      receivedConfirmation(this.state.helpfulnessChanged);
    }
  }

  onConfirmation = (confirmed) => {
    const { helpful, confirmRating, ratingUuid, ratingType } = this.props;
    const wasHelpful = confirmed ? helpful : !helpful;
    this.setState({ helpfulnessChanged: !confirmed });
    confirmRating(ratingUuid, wasHelpful, ratingType);
  };

  render() {
    const { helpful, theme } = this.props;

    return (
      <>
        <UnauthedHeader />
        <CenteredContainer
          width="40rem"
          title=""
          innerBackground={theme.palette.background.paper}
          border="0px"
          pagePadding="1rem"
          m="0"
          p="0"
        >
          <Div p="2rem">
            <Text variant="h1" color="primary" m="2rem 0">
              Confirm Your Feedback
            </Text>
            <Text variant="body1" mb="2rem">
              Thanks! Every time you submit a rating, it helps us make sure
              you're getting great feedback from PullRequest engineers.
            </Text>
            <Text variant="body1" mb="2rem">
              It looks like you've rated this review as
              <b>{helpful ? ' helpful' : ' not helpful'}</b>. Is that right?
            </Text>
            <Flex
              mb="1.5rem"
              direction="column"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                variant="contained"
                color="primary"
                p=".875rem"
                width="100%"
                onClick={() => this.onConfirmation(true)}
              >
                <Text variant="body1" color="inherit">
                  Yes, PullRequest
                  {helpful ? <b> was </b> : <b> was not </b>}
                  helpful {helpful ? '👍' : '🛑'}
                </Text>
              </Button>
              <Button
                variant="text"
                color="primary"
                p=".875rem"
                width="100%"
                onClick={() => this.onConfirmation(false)}
              >
                <Text variant="body1" color="primary">
                  No, PullRequest
                  {!helpful ? <b> was </b> : <b> was not </b>}
                  helpful {!helpful ? '👍' : '🛑'}
                </Text>
              </Button>
            </Flex>
            <Div>
              <Text variant="body2">
                Questions? email{' '}
                <Link variant="body2" href={mail.to(Email.SUPPORT).build()}>
                  {Email.SUPPORT}
                </Link>
              </Text>
            </Div>
          </Div>
        </CenteredContainer>
      </>
    );
  }
}

RatingConfirmation.propTypes = {
  ratingUuid: PropTypes.string.isRequired,
  helpful: PropTypes.bool.isRequired,
  hasConfirmed: PropTypes.bool.isRequired,
  confirmRating: PropTypes.func.isRequired,
  receivedConfirmation: PropTypes.func.isRequired,
  ratingType: PropTypes.string,
};

export default withTheme(RatingConfirmation);
